import { render } from "./ModalAddPessoa.vue?vue&type=template&id=372cabbe"
import script from "./ModalAddPessoa.vue?vue&type=script&lang=js"
export * from "./ModalAddPessoa.vue?vue&type=script&lang=js"

import "./ModalAddPessoa.vue?vue&type=style&index=0&id=372cabbe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__